import { combineReducers} from "redux";

function keycloakReducer(state={}, action){
    switch(action.type){
        case 'KEYCLOAK_LOGIN': return {
            keycloak: action.keycloak,
            authenticated: action.authenticated
        }
        default: return state
    }
}
function advisersReducer(state=[], action){
    switch(action.type){
        case 'GET_ADVISERS': return {
            ...state, 
            advisers: action.advisers,
            total: action.total,
            groupLogin: action.groupLogin,
            lastLoginDate: action.lastLoginDate
        }
        default: return state
    }
}
function adviserFeeReducer(state=[], action){
    switch(action.type){
        case 'GET_ADVISER_FEE_SUMMARY': return {
            ...state, 
            fees: action.fees
        }
        default: return state
    }
}

// function adviserFilterReducer(state=[], action){
//     switch(action.type){
//         case 'GET_SELECTED_ADVISER_ID': return {
//             ...state,
//             selectedAdviserId: action.id,
//         }

//         default: return state
//     }
// }

function memberListReducer(state=[], action){
    switch(action.type){
        case 'GET_MEMBER_LIST': return{
            ...state,
            memberList: action.memberList
        }
        case 'GET_SELECTED_ADVISER_ID': return {
            ...state,
            memberList: [],
            selectedAdviserId: action.id,
        }

        default: return state
    }
}

function memberReducer(state=[], action){
    switch(action.type){
        case 'GET_MEMBER_DETAILS' : return {
            ...state,
            member: action.member
        }
        default: return state
    }
}

function contributionReducer(state=[], action){
    switch(action.type){
        case 'GET_MEMBER_CONTRIBUTIONS' : return {
            ...state,
            memberContribution: action.memberContribution
        }
        default: return state
    }
}

function commissionsReducer(state=[], action){
    switch(action.type){
        case 'GET_COMMISSION_DETAILS': return{
            ...state,
            commissions: action.commissions
        }
        default: return state
    }
}

function accountBalancesReducer(state=[], action){
    switch(action.type){
        case 'GET_ACCOUNT_BALANCES': return{
            ...state,
            isAccountBalancesEmpty: action.empty,
            accountBalances: action.accountBalances,
            products: action.products,
            period: action.period
        }
        case 'GET_ACCOUNT_RETURNS': return{
            ...state,
            isAccountReturnsEmpty: action.empty,
            accountReturns: action.accountReturns,
        }
        default: return state
    }
}

function fundBalancesReducer(state=[], action){

    switch(action.type){
        case 'GET_FUND_BALANCES': return{
            ...state,
            isFundBalancesEmpty: action.empty,
            fundBalances: action.fundBalances,
            totalFunds: action.totalFunds
        }
        case 'GET_FUND_RETURNS': return{
            ...state,
            isFundReturnsEmpty: action.empty,
            fundReturns: action.fundReturns
        }
        default: return state
    }
}

function filterFundsReducer(state=[], action){
    switch(action.type){
        case 'GET_ACCOUNTS': return{
            ...state,
            accounts: action.accounts
        }
        case 'GET_FUNDS': return{
            ...state,
            funds: action.funds
        }
        default: return state
    }
}


function transactionsReducer(state=[], action){
    switch(action.type){
        case 'GET_MEMBER_TRANSACTIONS': return{
            ...state,
            isTransactionsEmpty: action.empty,
            transactions: action.transactions
        }
        default: return state
    }
}

function transactionsCSVReducer(state=[], action){
    switch(action.type){
        case 'DOWNLOAD_TRANSACTIONS_CSV': return{
            ...state,
            transactionsHeader: action.transactionsHeader,
            transactionsDetails: action.transactionsDetails
        }
        default: return state
    }
}

function futureStrategyReducer(state=[], action){
    switch(action.type){
        case 'GET_FUTURE_STRATEGY': return {
            ...state,
            futureStrategy: action.futureStrategy
        }
        default: return state
    }
}

function labelReducer(state=[], action){
    switch(action.type){
        case 'GET_LABEL': return {
            ...state,
            labelText: action.labelText
        }
        default: return state
            
    }
}

const rootReducer = combineReducers({keycloakReducer, advisersReducer, memberListReducer, commissionsReducer, 
    accountBalancesReducer, memberReducer, contributionReducer, fundBalancesReducer, filterFundsReducer, transactionsReducer, 
    transactionsCSVReducer, futureStrategyReducer, labelReducer, adviserFeeReducer});

export default rootReducer;